module.exports = __webpack_public_path__ + "img/backArrow.0632a7bd.svg";